import { connect } from 'react-redux';
import Shell from './shell';
import { withRouter } from '../../utils/withRouter';
import * as AC from '../../actions/actionCreators';

function mapStateToProps(state) {
	return {
		role: state.profile.role,
		sessionExpiresAt: state.profile.sessionExpiresAt
	};
}

function mapDispatchToProps(dispatch) {
	return {
		logout: () => dispatch(AC.ProfileLogout()),
		extendSession: () => dispatch(AC.ProfileSessionExtended())
	};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Shell));